import axios from 'src/api/axiosInstances/privateAxiosInstance';
import ProductSegment from '../types/ProductSegment';
import ProductSegmentList from '../types/ProductSegmentList';

export type CreateProductSegmentData = Partial<ProductSegment> & {
  productSegmentName: string;
};
type CreateProductSegmentResponse = {
  responseHeader: {
    id: number;
    statusCode: string;
    statusMessage: string;
  };
};

export type EditProductSegmentData = Partial<ProductSegment> & {
  productSegmentId: number;
};

export type CloneProductSegmentData = EditProductSegmentData;

export type UsersProductSegmentResponse = {
  segmentUser: {
    segmentUserList: string[];
  };
};

export const getProductSegments = (params: ProductSegmentList.Request): Promise<ProductSegmentList.Response> => {
  return axios.get('qm/productsegment/retriveall', { params });
};

export const getProductSegment = (segmentId: string): Promise<ProductSegment | null> => {
  // TODO: it's a temporary solution until Backend API is updated
  return axios.get('qm/productsegment/retriveall', { params: { size: -1 } }).then((res: any) => {
    const productSegmentList = res.productSegmentList;
    return productSegmentList.find((el: ProductSegment) => el.productSegmentId === Number(segmentId));
  });
};

export const createProductSegment = (data: CreateProductSegmentData): Promise<CreateProductSegmentResponse> => {
  return axios.post('qm/productsegment/add', data);
};

export const editProductSegment = (data: EditProductSegmentData): Promise<unknown> => {
  return axios.post('qm/productsegment/add', data);
};

export const removeProductSegment = (productSegmentId: number): Promise<unknown> => {
  return axios.delete(`qm/productsegment/remove?productSegmentId=${productSegmentId}`);
};

export const cloneProductSegment = (data: CloneProductSegmentData): Promise<unknown> => {
  return axios.post('qm/productsegment/clone', data);
};

export const getUsersProductSegment = (): Promise<UsersProductSegmentResponse> => {
  return axios.get('qm/productsegment/segmentuser');
};
